import { render, staticRenderFns } from "./BookingDetailsSummary.vue?vue&type=template&id=18a59a6c&scoped=true&"
import script from "./BookingDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./BookingDetailsSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetailsSummary.vue?vue&type=style&index=0&id=18a59a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a59a6c",
  null
  
)

export default component.exports